export const PreProd_Custom = [
    
    {
        "domainName": "test.humanadirect.com",
        data: {
            "data-domain-name": "",
            "layout_title": "Humana Direct Messaging",
            "layout_subpage_title": "- Humana - Direct Mail",
            "pre_register_login_header_text": "Sign In"
        }
    },
    {
        "domainName": "dev.direct.esante.healthcare",
        data: {
            "data-domain-name": "dev.direct.esante.healthcare",
            "layout_title": "Esante Healthcare Direct Messaging",
            "layout_subpage_title": "- Esante Healthcare - Direct Mail",
            "acr_values": "idp:EsanteDevIDP"
        }
    },
    {
        "domainName": "qa.direct.esante.healthcare",
        data: {
            "data-domain-name": "qa.direct.esante.healthcare",
            "layout_title": "Esante Healthcare Direct Messaging",
            "layout_subpage_title": "- Esante Healthcare - Direct Mail",
            "acr_values": "idp:EsanteQAIDP"
        }
    },
    {
        "domainName": "stage.direct.esante.healthcare",
        data: {
            "data-domain-name": "stage.direct.esante.healthcare",
            "layout_title": "Esante Healthcare Direct Messaging",
            "layout_subpage_title": "- Esante Healthcare - Direct Mail",
            "acr_values": "idp:OpenIdConnect"
        }
    },
    {
        "domainName": "test.crispdirect.org",
        data: {
            "data-domain-name": "",
            "layout_title": "CRISP Direct Messaging",
            "layout_subpage_title": "- CRISP - Direct Mail",
            "tfa-enabled": "true"
        }
    },

    {
        "domainName": "test.ctproviderdirect.org",
        data: {
            "data-domain-name": "",
            "layout_title": "CT Provider Direct Messaging",
            "layout_subpage_title": "- CT Provider - Direct Mail"
        }
    },

    {
        "domainName": "test.cchiedirect.com",
        data: {
            "data-domain-name": "",
            "layout_title": "Clinical Connect Direct Messaging",
            "layout_subpage_title": "- Clinical Connect - Direct Mail"
        }
    },
    {
        "domainName": "test.upmcdirect.com",
        data: {
            "data-domain-name": "test.upmcdirect.com",
            "layout_title": "UPMC Direct Messaging",
            "layout_subpage_title": "- UPMC - Direct Mail"
        }
    },
    {
        "domainName": "hddsmadmin.nchealthconnex.net",
        data: {
            "data-domain-name": "",
            "layout_title": "NC HealthConnex Direct Messaging",
            "layout_subpage_title": "- NC HealthConnex - Direct Mail"
        }
    },
    {
        "domainName": "dsmadmin.nchealthconnex.net",
        data: {
            "data-domain-name": "",
            "layout_title": "NC HealthConnex Direct Messaging",
            "layout_subpage_title": "- NC HealthConnex - Direct Mail"
        }
    }
];
